import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TEST_ROUTES } from 'app/pechkin/test/test.module';
import { MessageLogListComponent } from 'app/pechkin/messagelog/containers/message-log-list.component';
import { MessageLogViewComponent } from 'app/pechkin/messagelog/containers/message-log-view.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'test',
        children: TEST_ROUTES,
      },
      { path: 'message-logs', component: MessageLogListComponent },
      { path: 'message-logs/view/:id', component: MessageLogViewComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PechkinRoutingModule {}
